import { defineMessages } from 'react-intl';

export default defineMessages({
  cookieMessage: {
    id: 'app.containers.cookie.settings.cookie.message',
    defaultMessage: 'This site uses cookies',
  },
  moreInfosButton: {
    id: 'app.containers.cookie.settings.more.infos.button',
    defaultMessage: 'More',
  },
  okButton: {
    id: 'app.containers.cookie.settings.ok.button',
    defaultMessage: 'OK',
  },
});
